export const liveExampleStyleSpec = {
  ':host': {
    '--tosi-example-height': '320px',
    '--code-editors-bar-bg': '#777',
    '--code-editors-bar-color': '#fff',
    '--widget-bg': '#fff8',
    '--widget-color': '#000',
    position: 'relative',
    display: 'flex',
    height: 'var(--tosi-example-height)',
    background: 'var(--background)',
    boxSizing: 'border-box',
  },

  // Local-edit indicator: an accent outline on the always-visible `<>` example
  // button (bottom-left) when this example differs from its doc source — visible
  // whether or not the code editor is open (e.g. an auto-restored saved edit).
  ':host.-locally-edited [part="exampleWidgets"]': {
    outline: '2px solid var(--brand-color, #da1167)',
    outlineOffset: '1px',
    borderRadius: '4px',
  },

  ':host.-maximize': {
    position: 'fixed',
    left: '0',
    top: '0',
    height: '100vh',
    width: '100vw',
    margin: '0 !important',
  },

  '.-maximize': {
    zIndex: 101,
  },

  ':host.-vertical': {
    flexDirection: 'column',
  },

  ':host .layout-indicator': {
    transition: '0.5s ease-out',
    transform: 'rotateZ(270deg)',
  },

  ':host.-vertical .layout-indicator': {
    transform: 'rotateZ(180deg)',
  },

  ':host.-maximize .hide-if-maximized, :host:not(.-maximize) .show-if-maximized':
    {
      display: 'none',
    },

  ':host [part="example"]': {
    flex: '1 1 50%',
    height: '100%',
    position: 'relative',
    overflowX: 'auto',
  },

  ':host .preview': {
    height: '100%',
    position: 'relative',
    overflow: 'hidden',
    boxShadow: 'inset 0 0 0 2px #8883',
  },

  ':host .preview-error': {
    padding: '8px 12px',
    margin: '8px',
    background: '#fee',
    color: '#900',
    borderRadius: '4px',
    fontSize: '13px',
    fontFamily: 'system-ui, sans-serif',
    whiteSpace: 'pre-wrap',
  },

  ':host [part="editors"]': {
    flex: '1 1 200px',
    height: '100%',
    position: 'relative',
  },

  ':host [part="exampleWidgets"]': {
    position: 'absolute',
    left: '5px',
    bottom: '5px',
    '--widget-color': 'var(--brand-color)',
    borderRadius: '5px',
    width: '44px',
    height: '44px',
    lineHeight: '44px',
    zIndex: '100',
  },

  ':host [part="exampleWidgets"] svg': {
    stroke: 'var(--widget-color)',
  },

  ':host .code-editors': {
    overflow: 'hidden',
    background: 'white',
    position: 'relative',
    top: '0',
    right: '0',
    flex: '1 1 50%',
    height: '100%',
    flexDirection: 'column',
    zIndex: '10',
  },

  ':host .code-editors:not([hidden])': {
    display: 'flex',
  },

  ':host .code-editors > h4': {
    padding: '5px',
    margin: '0',
    textAlign: 'center',
    background: 'var(--code-editors-bar-bg)',
    color: 'var(--code-editors-bar-color)',
    cursor: 'move',
  },

  ':host button.transparent, :host .sizer': {
    width: '32px',
    height: '32px',
    lineHeight: '32px',
    textAlign: 'center',
    padding: '0',
    margin: '0',
  },

  ':host .sizer': {
    cursor: 'nwse-resize',
  },

  // Test status indicator (--tests-enabled CSS var pierces shadow DOM)
  ':host [part="testIndicator"]': {
    position: 'absolute',
    top: '8px',
    right: '8px',
    width: '12px',
    height: '12px',
    borderRadius: '50%',
    background: '#888',
    zIndex: '100',
    display: 'none',
  },

  ':host.-has-tests [part="testIndicator"]': {
    display: 'block',
    opacity: 'var(--tests-enabled, 1)',
  },

  ':host.-test-running [part="testIndicator"]': {
    background: '#fa0',
    animation: 'test-pulse 0.5s ease-in-out infinite',
  },

  ':host.-test-passed [part="testIndicator"]': {
    background: '#0a0',
    animation: 'test-fade 2s ease-out forwards',
  },

  ':host.-test-failed [part="testIndicator"]': {
    background: '#c00',
    animation: 'test-pulse 1s ease-in-out infinite',
  },

  '@keyframes test-pulse': {
    '0%, 100%': { opacity: '1' },
    '50%': { opacity: '0.4' },
  },

  '@keyframes test-fade': {
    '0%': { opacity: '1' },
    '50%': { opacity: '1' },
    '100%': { opacity: '0' },
  },

  ':host.-test-passed [part="exampleWidgets"]': {
    '--widget-color': '#0a0',
  },

  ':host.-test-failed [part="exampleWidgets"]': {
    '--widget-color': '#f00',
  },

  ':host [part="testResults"]': {
    position: 'absolute',
    bottom: '54px',
    left: '5px',
    background: 'var(--widget-bg)',
    borderRadius: '5px',
    padding: '8px',
    fontSize: '14px',
    margin: '0',
    maxWidth: '400px',
    maxHeight: '200px',
    overflow: 'auto',
    zIndex: '100',
  },

  ':host [part="testResults"][hidden]': {
    display: 'none',
  },

  ':host .test-pass': {
    color: '#0a0',
  },

  ':host .test-fail': {
    color: '#f00',
  },

  // Read-only "tjs tests" results tab (inline /*test*/ results).
  ':host .tjs-test-results': {
    padding: '8px 12px',
    fontSize: '14px',
    fontFamily: 'var(--mono-font, monospace)',
    overflow: 'auto',
    lineHeight: '1.6',
  },

  ':host .tjs-test-summary': {
    fontWeight: 'bold',
    marginBottom: '6px',
  },

  ':host .tjs-test-empty': {
    opacity: '0.6',
  },

  ':host .tjs-test-error': {
    opacity: '0.7',
  },
}
